var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.roleType==1)?_c('captainDataboard'):(_vm.roleType==6)?_c('navvyOwnerDataboard'):(_vm.roleType==7)?_c('garbageDataboard'):_c('databoard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }